<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#88699f" type = "ball-beat" [fullScreen] = "false"><p style="color: white" > Loading... </p></ngx-spinner>
<!-- <app-splash-screen></app-splash-screen> -->
<router-outlet></router-outlet>
